<template>
  <div
    :class="b({ fixed })"
    class="om-hairline-bottom"
    :style="style"
  >
    <div :class="b('left')" @click="$emit('click-left')">
      <slot name="left">
        <icon v-if="leftArrow" :class="b('arrow')" name="angle-left" />
        <span v-if="leftText" v-text="leftText" :class="b('text')" />
      </slot>
    </div>
    <div :class="b('title')" class="om-ellipsis">
      <slot name="title">{{ title }}</slot>
    </div>
    <div :class="b('right')" @click="$emit('click-right')">
      <slot name="right">
        <span v-if="rightText" v-text="rightText" :class="b('text')" />
      </slot>
    </div>
  </div>
</template>

<script>
import create from '../utils/create';

export default create({
  name: 'navbar',

  props: {
    title: String,
    leftText: String,
    rightText: String,
    leftArrow: Boolean,
    fixed: Boolean,
    zIndex: {
      type: Number,
      default: 1
    }
  },

  computed: {
    style() {
      return {
        zIndex: this.zIndex,
        position: this.fixed ? 'fixed' : 'inherit'
      };
    }
  }
});
</script>



// WEBPACK FOOTER //
// src/plugins/jscom/omui/components/navbar/index.vue